
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CircleChart } from "./components/CricleChart";
import useFetch from "./useFetch";

const StockCard = (props) => {
  const navigate = useNavigate();
  const ticker = props.ticker;

  // Handle navigation to stock details
  const handleDetails = (e) => {
    navigate("/stock/" + e.target.value);
  };

  const handleRemove = (e) => {
    props.handleRemove(e.target.value);
  };

  // Fetch stock rating data from backend
  const server = "https://app.cuetraders.com";
  const url = server+"/api/get_stock_rating.php?ticker="+ticker;
  let { data } = useFetch(url);

  // Inform parent about new stock data
  useEffect(() => {
    if (data && data.success) {
      props.setStockData(data.stock_rating[0]);
      console.log("Fetched rating for", ticker, data.stock_rating[0]);
    } else if (data && !data.success) {
      console.log("Fetch error: " + ticker);
      props.handleRemove(ticker);
    }
  }, [data]);

  // ✅ Price and change: prefer parent props, fallback to fetched rating
  const priceFromParent = props.price;
  const changeFromParent = props.change;

  const fallbackPrice = data?.stock_rating?.[0]?.Price ?? "-";
  const fallbackChange = data?.stock_rating?.[0]?.ChangeUSD ?? "-";

  const price = priceFromParent ?? fallbackPrice;
  const changeUSD = changeFromParent ?? fallbackChange;

  return (
    <div id={ticker}>
      {data && data.success && (
        <>
          <div className="col-lg-4 col-sm-6 col-xs-12">
            <div className="panel panel-default">
              {/* === Panel Heading with Star Rating and Price === */}
              <div className="panel-heading comparePanelsHeaderStyle">
                <div align="rigth">
                  <div className="SFscore">
                    {[1, 2, 3, 4, 5].map(
                      (n) =>
                        +data.stock_rating[0].Rating >= n && (
                          <i key={n} className="fa fa-star"></i>
                        )
                    )}
                  </div>

                  <div align="left">
                    <div className="sm-company">
                      {data.stock_rating[0].CompanyName || " -- "}
                    </div>
                    <div className="sm-symbol">{ticker}</div>
                    <div className="sm-quote-div">
                      <span className="sm-quote">${price}</span>
                      <span className="sm-change-div">
                        {+changeUSD >= 0 && (
                          <span className="sm-change-green">
                            +{changeUSD}
                          </span>
                        )}
                        {+changeUSD < 0 && (
                          <span className="sm-change-red">
                            ({changeUSD})
                          </span>
                        )}
                      </span>
                    </div>
                    <div className="sm-symbol" align="right">
                      Score: {Math.round(data.stock_rating[0].AppScore)}
                    </div>
                  </div>
                </div>
              </div>

              {/* === Metrics Section === */}
              <div className="panel-body">
                <div className="widget-tabs-2">
                  <div className="tab-chart-track-color">
                    {[
                      "Growth",
                      "Valuation",
                      "Profitability",
                      "Strength",
                      "Sentiment",
                      "Momentum",
                    ].map((metric, idx) => {
                      const key = metric + "Score";
                      const score = Math.round(
                        4 * data.stock_rating[0][key]
                      );
                      return (
                        <React.Fragment key={metric}>
                          <div className="l-span-xs-7">
                            <div className="tab-2-title">{metric}</div>
                            <div className="icon-hover tab-2-info">
                              {[20, 40, 60, 80].map((threshold) => (
                                <i
                                  key={threshold}
                                  className={
                                    score >= threshold
                                      ? "fa fa-check"
                                      : "fa fa-close"
                                  }
                                ></i>
                              ))}
                            </div>
                          </div>
                          <div className="l-span-xs-5 tab-chart-wrapper">
                            <span
                              data-percent={score}
                              className={`tabChart${idx + 1} tab-chart`}
                            >
                              <CircleChart
                                score={score}
                                size="50px"
                              ></CircleChart>
                            </span>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* === Footer Buttons === */}
              <div className="panel-footer" align="center">
                <div className="l-row">
                  <button
                    type="button"
                    className="btn-red"
                    onClick={handleRemove}
                    value={ticker}
                  >
                    Remove
                  </button>
                  <button
                    type="button"
                    className="btn-green"
                    onClick={handleDetails}
                    value={ticker}
                  >
                    Details
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default StockCard;
